import {SplitButtonSkeleton} from '@sollapay/ui/components';

import {TrustAccountShareButton} from './TrustAccountShareButton';
import {useShareButtonQueries} from '../hooks';

import type {MoreMenuItem} from '@sollapay/ui/components';
import type {FC, ReactNode} from 'react';

export interface TrustAccountShareControlProps {
  trustAccountId: string;
  accountName: string;
  accountMenuItems?: MoreMenuItem[];
  /** Shown when the roster can't be read; the share button needs it. */
  fallback?: ReactNode;
}

/** The Share button wherever an account page shows it: a skeleton until the roster settles. */
export const TrustAccountShareControl: FC<TrustAccountShareControlProps> = ({
  trustAccountId,
  accountName,
  accountMenuItems,
  fallback = null
}) => {
  const {roster, isRosterPending} = useShareButtonQueries(trustAccountId);

  if (roster) {
    return (
      <TrustAccountShareButton
        trustAccountId={trustAccountId}
        accountName={accountName}
        roster={roster}
        accountMenuItems={accountMenuItems}
      />
    );
  }
  return isRosterPending ? <SplitButtonSkeleton /> : fallback;
};
